import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { INSMSession } from './insm-session';
import { AnimationFPSIM } from './period-measurers/afps';
import { INPTracker } from './inp-measurers/inp';
export var INSM = /*#__PURE__*/function () {
  function INSM(options) {
    var _this = this;
    _classCallCheck(this, INSM);
    /**
     * Heavy tasks are tracked at the insm layer as heavy tasks
     * are expected at times to be unrelated to the current
     * page session.
     */
    _defineProperty(this, "runningHeavyTasks", new Set());
    this.periodMeasurers = [new AnimationFPSIM(), new INPTracker()];
    this.options = options;

    // If this does throw -- we do want an unhandledRejection rejection to be passed to the window
    // this is to ease debugging.
    options.getAnalyticsWebClient.then(function (analyticsWebClient) {
      return _this.analyticsWebClient = analyticsWebClient;
    });

    // No cleanup needs to be performed -- as this tooling is intended to run until the tab is closed
    // The use of beforeunload here is because using pagehide does not reliably result in the analytics
    // being fired by the analytics web client.
    // The use of this means we will miss events from mobile safari which does not reliably call this api
    // however mobile browsers do not call when a browser closes - so we expect limited mobile data from
    // this tooling in its current form.

    // window will not be defined in server envs - in these envs -- there can never be a session end
    if (typeof window !== 'undefined') {
      // eslint-disable-next-line @repo/internal/dom-events/no-unsafe-event-listeners
      window.addEventListener('beforeunload', function () {
        var _this$runningSession;
        (_this$runningSession = _this.runningSession) === null || _this$runningSession === void 0 || _this$runningSession.end({
          stoppedBy: 'beforeunload'
        });
      });
    }
  }

  /**
   * Starts a heavy task in the currently running session.
   *
   * This also pauses measurement.
   */
  return _createClass(INSM, [{
    key: "startHeavyTask",
    value: function startHeavyTask(heavyTaskName) {
      var _this$runningSession2, _this$runningSession3;
      this.runningHeavyTasks.add(heavyTaskName);
      (_this$runningSession2 = this.runningSession) === null || _this$runningSession2 === void 0 || (_this$runningSession2 = _this$runningSession2.periodTracking) === null || _this$runningSession2 === void 0 || _this$runningSession2.startHeavyTask(heavyTaskName);
      (_this$runningSession3 = this.runningSession) === null || _this$runningSession3 === void 0 || _this$runningSession3.periodTracking.pause(heavyTaskName);
    }

    /**
     * Ends a heavy task in the currently running session
     */
  }, {
    key: "endHeavyTask",
    value: function endHeavyTask(heavyTaskName) {
      var _this$runningSession4;
      this.runningHeavyTasks.delete(heavyTaskName);
      (_this$runningSession4 = this.runningSession) === null || _this$runningSession4 === void 0 || _this$runningSession4.periodTracking.resume(heavyTaskName);
    }

    /**
     * Call this when starting a new experience.  This is expected to be wired to the product
     * routing solution.
     *
     * It's expected this call will be paired with a `insm.session.startHeavyTask('page-load')` and subsequent `insm.session.endHeavyTask('page-load')`
     * so that performance degradations linked to the page initialisation are excluded from the active interactivity monitoring.
     *
     *
     * ```ts
     * insm.start('edit-page', { initial: true, contentId: '9001' })
     * insm.session.startHeavyTask(''page-load')
     * // ... heavy initialisation work
     * insm.session.endHeavyTask(''page-load')
     * ```
     */
  }, {
    key: "start",
    value: function start(experienceKey, experienceProperties) {
      var _this$options$experie;
      if (this.runningSession !== undefined) {
        this.runningSession.end({
          stoppedBy: 'new-experience',
          experienceKey: experienceKey,
          contentId: experienceProperties.contentId
        });
      }
      if ((_this$options$experie = this.options.experiences[experienceKey]) !== null && _this$options$experie !== void 0 && _this$options$experie.enabled) {
        this.runningSession = new INSMSession(experienceKey, experienceProperties, this);
      }
    }

    /**
     * This prematurely halts any running experience measurement. It's expected to be used in
     * scenarios such as when error boundaries are hit.
     */
  }, {
    key: "stopEarly",
    value: function stopEarly(reasonKey, description) {
      var _this$runningSession5;
      (_this$runningSession5 = this.runningSession) === null || _this$runningSession5 === void 0 || _this$runningSession5.earlyStop(reasonKey, description);
    }

    /**
     * Gets the current running session details
     */
  }, {
    key: "session",
    get: function get() {
      return this.runningSession;
    }
  }]);
}();